(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/init.js');
'use strict';

const MyProfileApp = svs.myProfile.MyProfileApp;
svs.myProfile.init = () => {
  ReactDOM.render(React.createElement(MyProfileApp, null), document.getElementById('react-container'));
};
svs.myProfile.init();

 })(window);